export const LOCALES ={
	ENGLISH: 'en',
    ARABIC: 'ar',
    CHATBOT_AR: "ar-AE",
    CHATBOT_EN: "en-US",
};